import * as React from 'react';

import { DEFAULT_COLOR_PALETTE } from '@/lib/constants/colors';
import { cn } from '@/lib/utils';

type TextareaProps = React.ComponentProps<'textarea'> & {
  hasWarning?: boolean;
};

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, hasWarning = false, style, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:border-input disabled:opacity-100 disabled:bg-muted disabled:pointer-events-none md:text-sm',
          className
        )}
        style={
          hasWarning
            ? {
                outline: `2px solid ${DEFAULT_COLOR_PALETTE.amber}`,
                outlineOffset: '2px',
                ...style,
              }
            : style
        }
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
